

<main id="main" class="main">


  <section class="section dashboard">

<div class="row">

    <form class="plansform">
      <div class="row">
        <div class="form-group col-12 col-md-12">
          <h6 class="admintitle">Details&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6>

      </div>

<!-- id,fusbilid,Name,parent Name,childents count,Email,phone,status,details -->

    <div class="row">
              <div class="col-md-4">
                 <div class="card">
                    <div class="card-body">
<div>
  <b>IGBMS Id Details</b>
</div>
<div class="row">
  IGBMS Id:
</div>
<div class="row">
  IGBMS Id Status:
</div>
                    </div>
                 </div>

              </div>
              <div class="col-md-4">
                <div class="card">
                   <div class="card-body">
<div>
 <b>Account Details</b>
</div>
<div class="row">
Name:
</div>
<div class="row">
Status:
</div>
                   </div>
                </div>

             </div>
             <div class="col-md-4">
              <div class="card">
                 <div class="card-body">
<div>
<b>Payment Details</b>
</div>
<div class="row">
Name:
</div>
<div class="row">
Status:
</div>
                 </div>
              </div>

           </div>

  </div>


  <div class="row">
    <div class="col-md-4">
       <div class="card">
          <div class="card-body">
<div>
<b>Billing Address</b>
</div>
<div class="row">
Fusbill id:
</div>
<div class="row">
Fusbill Status:
</div>
          </div>
       </div>

    </div>
    <div class="col-md-4">
      <div class="card">
         <div class="card-body">
<div>
<b>Booklets</b>
</div>
<div class="row">
Name:
</div>
<div class="row">
Status:
</div>
         </div>
      </div>

   </div>
   <div class="col-md-4">
    <div class="card">
       <div class="card-body">
<div>
<b>Plans</b>
</div>
<div class="row">
Name:
</div>
<div class="row">
Status:
</div>
       </div>
    </div>

 </div>

</div>
  <!-- <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top"> Tooltip on top </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="right" title="Tooltip on right"> Tooltip on right </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tooltip on bottom"> Tooltip on bottom </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="left" title="Tooltip on left"> Tooltip on left </button> -->

  </div>

      </form>

      <div class="row">
        <div class=" text-white text-left">
          <!-- <button class="btn btn-primary" id="backbuttonForm"
          type="button" (click)="gotoplansorwalletInfo()" style="float:left"><i aria-hidden="true" class="fa fa-long-arrow-left" ></i>&nbsp;&nbsp;Previous</button> -->

        </div>
        <div class=" text-white text-right">
          <!-- <button class="btn btn-primary" id="basicformSubmit" type="button" (click)="submitEmployeeInfoInfo()"> Save</button> -->
        </div>
      </div>



  </div>
  </section>
  </main>





  <footer id="footer" class="footer">
    <div class="copyright">Version IB:2.0.1  © 2025 Copyright:
      <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank"> The GroupBenefitz Platform Inc.</a></div>
 </footer>
 <a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
 <!-- <main id="main" class="main">
  <div class="mainScreen">
    <span>Work in Progress!</span>
  </div>
  </main> -->

